module.exports = __webpack_public_path__ + "media/hyper/images/waves-625cbc428eb491a3e1b4d73230143428.png";